// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.labeling-panel {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.labeling-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #e0e0e0;
}

.labeling-header h2 {
  margin: 0;
  color: #333;
}

.labeling-stats {
  font-weight: bold;
  color: #666;
}

.audio-player {
  margin-bottom: 30px;
}

.audio-player h3 {
  margin-bottom: 15px;
  color: #333;
}

.audio-element {
  width: 100%;
  margin-bottom: 10px;
}

.audio-error {
  color: #d32f2f;
  background: #ffebee;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
  border: 1px solid #f44336;
}

/* Progress Indicator */
.labeling-progress {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  position: relative;
}

.labeling-progress::before {
  content: '';
  position: absolute;
  top: 20px;
  left: 10%;
  right: 10%;
  height: 2px;
  background: #e0e0e0;
  z-index: 1;
}

.progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
}

.progress-step span {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 8px;
  border: 3px solid white;
}

.progress-step.active span {
  background: #2196f3;
  color: white;
  box-shadow: 0 0 0 3px #bbdefb;
}

.progress-step.completed span {
  background: #4caf50;
  color: white;
}

.progress-step p {
  margin: 0;
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

.progress-step.active p {
  color: #2196f3;
  font-weight: bold;
}

/* Labeling Steps */
.labeling-step {
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.labeling-step h3 {
  margin-top: 0;
  margin-bottom: 25px;
  color: #333;
  text-align: center;
  font-size: 1.5em;
}

/* Shortcut Grid */
.shortcut-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 25px;
}

.shortcut-item {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid transparent;
  transition: all 0.2s ease;
}

.shortcut-item:hover {
  border-color: #2196f3;
  background: #e3f2fd;
}

.shortcut-item kbd {
  background: #333;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-weight: bold;
  margin-right: 15px;
  min-width: 50px;
  text-align: center;
}

.shortcut-item.confirm kbd {
  background: #4caf50;
}

.shortcut-item.restart kbd {
  background: #ff9800;
}

/* Selected Type Display */
.selected-type {
  text-align: center;
  margin-bottom: 25px;
  padding: 15px;
  background: #e8f5e8;
  border-radius: 8px;
  border: 1px solid #4caf50;
  color: #2e7d32;
  font-size: 1.1em;
}

/* Confirmation Step */
.confirm-step {
  text-align: center;
}

.label-summary {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
  margin-bottom: 30px;
  border: 2px solid #e0e0e0;
}

.label-item {
  font-size: 1.2em;
  margin-bottom: 15px;
  padding: 10px;
}

.label-item:last-child {
  margin-bottom: 0;
}

.confirmation-actions {
  margin: 30px 0;
}

/* Instructions */
.step-instructions {
  text-align: center;
  color: #666;
  font-style: italic;
  margin-top: 20px;
}

.global-instructions {
  text-align: center;
  padding: 15px;
  background: #fff3e0;
  border-radius: 8px;
  margin-top: 20px;
  border: 1px solid #ffb74d;
}

.global-instructions kbd {
  background: #ff9800;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: bold;
}

/* No Audio State */
.no-audio {
  text-align: center;
  padding: 60px 20px;
}

.no-audio h3 {
  color: #666;
  margin-bottom: 15px;
}

.retry-btn {
  background: #2196f3;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  margin: 10px;
}

.retry-btn:hover {
  background: #1976d2;
}

/* Loading State */
.loading {
  text-align: center;
  padding: 60px 20px;
  font-size: 1.2em;
  color: #666;
}

/* Logout button styling */
.logout-btn {
  background: #f44336;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 15px;
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
}

.logout-btn:hover {
  background: #d32f2f;
}

/* Add to your LabelingPage.css */
.logout-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.logout-modal {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 90%;
  text-align: center;
}

.logout-modal-header h3 {
  margin: 0 0 1rem 0;
  color: #e74c3c;
  font-size: 1.3rem;
}

.logout-modal-body {
  margin-bottom: 1.5rem;
  line-height: 1.5;
  color: #333;
}

.logout-modal-body p {
  margin: 0.5rem 0;
}

.logout-modal-actions {
  display: flex;
  justify-content: center;
}

.logout-modal-actions .logout-btn {
  background: #e74c3c;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  font-size: 1rem;
  transition: background 0.2s;
}

.logout-modal-actions .logout-btn:hover {
  background: #c0392b;
}`, "",{"version":3,"sources":["webpack://./src/components/LabelingPage.css"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["\n.labeling-panel {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.labeling-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.labeling-header h2 {\n  margin: 0;\n  color: #333;\n}\n\n.labeling-stats {\n  font-weight: bold;\n  color: #666;\n}\n\n.audio-player {\n  margin-bottom: 30px;\n}\n\n.audio-player h3 {\n  margin-bottom: 15px;\n  color: #333;\n}\n\n.audio-element {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.audio-error {\n  color: #d32f2f;\n  background: #ffebee;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 15px;\n  border: 1px solid #f44336;\n}\n\n/* Progress Indicator */\n.labeling-progress {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 40px;\n  position: relative;\n}\n\n.labeling-progress::before {\n  content: '';\n  position: absolute;\n  top: 20px;\n  left: 10%;\n  right: 10%;\n  height: 2px;\n  background: #e0e0e0;\n  z-index: 1;\n}\n\n.progress-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  z-index: 2;\n}\n\n.progress-step span {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #e0e0e0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  margin-bottom: 8px;\n  border: 3px solid white;\n}\n\n.progress-step.active span {\n  background: #2196f3;\n  color: white;\n  box-shadow: 0 0 0 3px #bbdefb;\n}\n\n.progress-step.completed span {\n  background: #4caf50;\n  color: white;\n}\n\n.progress-step p {\n  margin: 0;\n  font-size: 14px;\n  color: #666;\n  font-weight: 500;\n}\n\n.progress-step.active p {\n  color: #2196f3;\n  font-weight: bold;\n}\n\n/* Labeling Steps */\n.labeling-step {\n  background: white;\n  padding: 30px;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n.labeling-step h3 {\n  margin-top: 0;\n  margin-bottom: 25px;\n  color: #333;\n  text-align: center;\n  font-size: 1.5em;\n}\n\n/* Shortcut Grid */\n.shortcut-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 15px;\n  margin-bottom: 25px;\n}\n\n.shortcut-item {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 2px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.shortcut-item:hover {\n  border-color: #2196f3;\n  background: #e3f2fd;\n}\n\n.shortcut-item kbd {\n  background: #333;\n  color: white;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-weight: bold;\n  margin-right: 15px;\n  min-width: 50px;\n  text-align: center;\n}\n\n.shortcut-item.confirm kbd {\n  background: #4caf50;\n}\n\n.shortcut-item.restart kbd {\n  background: #ff9800;\n}\n\n/* Selected Type Display */\n.selected-type {\n  text-align: center;\n  margin-bottom: 25px;\n  padding: 15px;\n  background: #e8f5e8;\n  border-radius: 8px;\n  border: 1px solid #4caf50;\n  color: #2e7d32;\n  font-size: 1.1em;\n}\n\n/* Confirmation Step */\n.confirm-step {\n  text-align: center;\n}\n\n.label-summary {\n  background: #f8f9fa;\n  padding: 25px;\n  border-radius: 8px;\n  margin-bottom: 30px;\n  border: 2px solid #e0e0e0;\n}\n\n.label-item {\n  font-size: 1.2em;\n  margin-bottom: 15px;\n  padding: 10px;\n}\n\n.label-item:last-child {\n  margin-bottom: 0;\n}\n\n.confirmation-actions {\n  margin: 30px 0;\n}\n\n/* Instructions */\n.step-instructions {\n  text-align: center;\n  color: #666;\n  font-style: italic;\n  margin-top: 20px;\n}\n\n.global-instructions {\n  text-align: center;\n  padding: 15px;\n  background: #fff3e0;\n  border-radius: 8px;\n  margin-top: 20px;\n  border: 1px solid #ffb74d;\n}\n\n.global-instructions kbd {\n  background: #ff9800;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-weight: bold;\n}\n\n/* No Audio State */\n.no-audio {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.no-audio h3 {\n  color: #666;\n  margin-bottom: 15px;\n}\n\n.retry-btn {\n  background: #2196f3;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  margin: 10px;\n}\n\n.retry-btn:hover {\n  background: #1976d2;\n}\n\n/* Loading State */\n.loading {\n  text-align: center;\n  padding: 60px 20px;\n  font-size: 1.2em;\n  color: #666;\n}\n\n/* Logout button styling */\n.logout-btn {\n  background: #f44336;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-left: 15px;\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  z-index: 1000;\n}\n\n.logout-btn:hover {\n  background: #d32f2f;\n}\n\n/* Add to your LabelingPage.css */\n.logout-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.logout-modal {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  max-width: 400px;\n  width: 90%;\n  text-align: center;\n}\n\n.logout-modal-header h3 {\n  margin: 0 0 1rem 0;\n  color: #e74c3c;\n  font-size: 1.3rem;\n}\n\n.logout-modal-body {\n  margin-bottom: 1.5rem;\n  line-height: 1.5;\n  color: #333;\n}\n\n.logout-modal-body p {\n  margin: 0.5rem 0;\n}\n\n.logout-modal-actions {\n  display: flex;\n  justify-content: center;\n}\n\n.logout-modal-actions .logout-btn {\n  background: #e74c3c;\n  color: white;\n  border: none;\n  padding: 0.75rem 2rem;\n  border-radius: 6px;\n  cursor: pointer;\n  font-weight: bold;\n  font-size: 1rem;\n  transition: background 0.2s;\n}\n\n.logout-modal-actions .logout-btn:hover {\n  background: #c0392b;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
